<template>
  <v-row class="mb-2 flex-wrap select-vehicle-root">
    <!--ALERT-->
    <v-col cols="12" md="12" lg="12">
      <v-alert
        :model-value="alert.value"
        :type="alert.type"
        variant="tonal"
        border="bottom"
      >
        {{ alert.message }}
      </v-alert>
    </v-col>
    <!--BRAND-->
    <v-col cols="12" sm="6" lg="2" md="2">
        <v-autocomplete
          v-model="car.brand"
          :items="brands"
          :label="$t('parts.advanced_search.brand')"
          item-title="title"
          item-value="brandCode"
          variant="outlined"
          color="red-darken-1"
          hide-details
          return-object
          autocomplete="off"
          :auto-select-first="false"
        >
          <template #item="{ props, item }">
            <v-list-item v-bind="props">
              <template #prepend>
                <v-img
                  :src="item.raw.logo"
                  height="35"
                  width="35"
                  class="mr-3"
                  cover
                />
              </template>
              <!-- <v-list-item-title>{{ item.raw.title }}</v-list-item-title> -->
            </v-list-item>
          </template>

          <!-- Selected value in the field -->
          <template #selection="{ item }">
            <div class="d-flex align-center">
              <v-img
                :src="item.raw.logo"
                height="35"
                width="35"
                class="mr-3"
                cover
              />
              <span>{{ item.raw.title }}</span>
            </div>
          </template>
        </v-autocomplete>
      </v-col>
      <!--MODEL-->
      <v-col cols="12" sm="6" lg="4" md="4">
        <v-row class="ma-0 flex-nowrap flex-sm-wrap">
          <v-col cols="12" class="pa-0">
          <v-combobox
            v-model="car.model"
            :items="models"
            :label="$t('parts.advanced_search.model')"
            item-title="fullDescription"
            item-value="modelCode"
            variant="outlined"
            color="red-darken-1"
            hide-details
            return-object
            clearable
            autocomplete="off"
            :auto-select-first="false"
            class="car-search-combobox"
          >
            <template #item="{ props, item }">
              <v-list-item v-bind="props">
                <v-list-item-content>
                  <v-row>
                    <!-- Description -->
                    <v-col cols="12" md="4" class="bg-grey-lighten-3 mt-2">
                      <div class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.model")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.fullDescription || item.raw.description
                        }}</span>
                      </div>
                    </v-col>

                    <!-- Year range -->
                    <v-col
                      cols="12"
                      md="8"
                      class="bg-grey-lighten-3 mt-2"
                    >
                      <div class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>

            <!-- Selected value -->
            <template #selection="{ item }">
              <div
                class="car-detail-selection d-flex justify-between align-center pa-2 w-100"
              >
                <div class="car-detail-col d-flex flex-column pr-2">
                  <span class="caption">{{
                    $t("parts.advanced_search.model")
                  }}</span>
                  <span class="font-weight-bold">{{
                    item.raw.fullDescription || item.raw.description
                  }}</span>
                </div>
                <div class="car-detail-col d-flex flex-column">
                  <span class="caption">{{
                    $t("parts.advanced_search.year")
                  }}</span>
                  <span class="font-weight-bold">
                    {{ formatMonthYear(item.raw.startingDate) }} -
                    {{ formatMonthYear(item.raw.endingDate) }}
                  </span>
                </div>
              </div>
            </template>
          </v-combobox>

          <v-menu
            v-if="car.model && car.model.customModel"
            v-model="modelDateMenu"
            :close-on-content-click="false"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template #activator="{ on }">
              <v-btn text icon v-on="on">
                <v-icon> event </v-icon>
              </v-btn>
            </template>
            <v-date-picker
              v-model="car.model.startingDate"
              color="red-darken-3"
              type="month"
              @input="modelDateMenu = false"
            />
          </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <!--VERSION-->
      <v-col cols="12" sm="6" lg="6" md="6">
        <v-combobox
          v-model="car.version"
          :items="versions"
          :label="$t('parts.advanced_search.version')"
          item-title="fullDescription"
          item-value="versionCode"
          variant="outlined"
          color="red-darken-1"
          hide-details
          return-object
          clearable
          autocomplete="off"
          :auto-select-first="false"
          class="car-search-combobox car-search-version-combobox"
        >
          <!-- Dropdown items -->
          <template #item="{ item, props }">
            <v-list-item v-bind="props">
              <div
                class="d-sm-none car-version-detail-item bg-grey-lighten-3 mt-2 pa-3 w-100"
              >
                <div
                  class="car-version-detail-row car-version-detail-row--dropdown"
                >
                  <div
                    class="car-version-detail-col car-version-detail-col--main"
                  >
                    <span class="caption">{{
                      $t("parts.advanced_search.version")
                    }}</span>&nbsp;
                    <span class="font-weight-bold">{{
                      item.raw.fullDescription || item.raw.description
                    }}</span>
                  </div>
                  <div class="car-version-detail-col">
                    <span class="caption">{{
                      $t("parts.advanced_search.year")
                    }}</span>&nbsp;
                    <span class="font-weight-bold">
                      {{ formatMonthYear(item.raw.startingDate) }} -
                      {{ formatMonthYear(item.raw.endingDate) }}
                    </span>
                  </div>
                  <div class="car-version-detail-col">
                    <span class="caption">{{
                      $t("parts.advanced_search.body")
                    }}</span>&nbsp;
                    <span class="font-weight-bold">{{
                      item.raw.numberOfDoors
                    }}</span>
                  </div>
                  <div class="car-version-detail-col">
                    <span class="caption">{{
                      $t("parts.advanced_search.power")
                    }}</span>&nbsp;
                    <span class="font-weight-bold">
                      {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                    </span>
                  </div>
                  <div class="car-version-detail-col">
                    <span class="caption">{{
                      $t("parts.advanced_search.engine")
                    }}</span>&nbsp;
                    <span class="font-weight-bold">{{
                      item.raw.engineCode
                    }}</span>
                  </div>
                  <div class="car-version-detail-col">
                    <span class="caption">{{
                      $t("parts.advanced_search.supply.supply")
                    }}</span>&nbsp;
                    <span class="font-weight-bold">{{
                      getSupplyLocale(item.raw.supplyCode)
                    }}</span>
                  </div>
                </div>
              </div>
                    <v-row class="d-none d-sm-flex pa-3 bg-grey-lighten-3 mt-2">
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.version")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.fullDescription || item.raw.description
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.body")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.numberOfDoors
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.power")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.engine")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.engineCode
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.supply.supply")
                          }}</span>
                          <span class="font-weight-bold">{{
                            getSupplyLocale(item.raw.supplyCode)
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
            </v-list-item>
          </template>

          <!--SELECTED-->
          <template #selection="{ item }">
            <div class="car-version-detail-selection car-detail-selection w-100 d-sm-none">
              <div class="car-version-detail-row">
                <div
                  class="car-version-detail-col car-version-detail-col--main"
                >
                  <span class="caption">
                    {{ $t("parts.advanced_search.version") }}
                  </span>
                  <span class="font-weight-bold">{{
                    item.raw.fullDescription || item.raw.description
                  }}</span>
                </div>
                <div class="car-version-detail-col">
                  <span class="caption">{{
                    $t("parts.advanced_search.year")
                  }}</span>
                  <span class="font-weight-bold">
                    {{ formatMonthYear(item.raw.startingDate) }} -
                    {{ formatMonthYear(item.raw.endingDate) }}
                  </span>
                </div>
                <div class="car-version-detail-col">
                  <span class="caption">{{
                    $t("parts.advanced_search.body")
                  }}</span>
                  <span class="font-weight-bold">{{
                    item.raw.numberOfDoors
                  }}</span>
                </div>
                <div class="car-version-detail-col">
                  <span class="caption">{{
                    $t("parts.advanced_search.power")
                  }}</span>
                  <span class="font-weight-bold">
                    {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                  </span>
                </div>
                <div class="car-version-detail-col">
                  <span class="caption">{{
                    $t("parts.advanced_search.engine")
                  }}</span>
                  <span class="font-weight-bold">{{
                    item.raw.engineCode
                  }}</span>
                </div>
                <div class="car-version-detail-col">
                  <span class="caption">{{
                    $t("parts.advanced_search.supply.supply")
                  }}</span>
                  <span class="font-weight-bold">{{
                    getSupplyLocale(item.raw.supplyCode)
                  }}</span>
                </div>
              </div>
            </div>
                  <v-row class="pa-2 d-none d-sm-flex">
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">
                          {{ $t("parts.advanced_search.version") }}
                        </span>
                        <span class="font-weight-bold">{{
                          item.raw.fullDescription || item.raw.description
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
          </template>
        </v-combobox>
      </v-col>
  </v-row>
</template>

<script>
import moment from "moment";

import getRequest from "../../api/getRequest";

export default {
  filters: {
    moment(date) {
      moment.locale(localStorage.getItem("language"));
      const valid = moment(date).isValid();
      if (valid) return moment(date).format("MM/YYYY");
      return "";
    },
  },
  data: () => ({
    loading: false,
    loadingBrand: false,
    loadingModel: false,
    loadingVersion: false,
    brands: [],
    models: [],
    versions: [],
    car: {
      brand: null,
      model: null,
      version: null,
    },
    alert: {
      value: false,
      type: "info",
      message: "",
    },
    customModel: false,
    modelDateMenu: false,
    modelDate: new Date().toISOString().split("-").slice(0, 2).join("-"),

    prevent: false, // Prevent from calling `get*` methods
  }),
  watch: {
    "car.brand": {
      handler(value) {
        if (value) {
          if (typeof value === "string") {
            // Set custom brand.
            this.car.brand = {
              brandCode: 0,
              categoryCode: 0,
              logo: "",
              title: value.toUpperCase(),
            };
          }

          this.models = [];
          this.car.model = null;
          this.versions = [];
          this.car.version = null;
          if (!this.prevent) this.getModels(value.brandCode);
        }
      },
    },
    "car.model": {
      handler(value) {
        if (value) {
          if (typeof value === "string") {
            // Set custom model.
            this.car.model = {
              brandCode: this.car.brand.brandCode,
              modelCode: 0,
              description: value,
              fullDescription: value,
              startingDate: null,
              endingDate: null,
              customModel: true,
            };
          }

          this.versions = [];
          this.car.version = null;
          if (!this.prevent) this.getVersions(value.brandCode, value.modelCode);
        }
      },
    },
    "car.version": {
      handler(value) {
        if (value) {
          if (typeof value === "string") {
            // Set custom version.
            this.car.version = {
              brandCode: this.car.brand.brandCode,
              modelCode: this.car.model.modelCode,
              versionCode: 0,
              description: value,
              startingDate: this.car.model.startingDate,
              endingDate: this.car.model.endingDate,
              chassisCode: "",
              engineCode: "",
              numberOfDoors: 0,
              supplyCode: "",
              displacement: { cc: 0 },
              power: { kw: 0 },
              tractionCode: "",
              fullDescription: value,
            };
          }

          this.$emit("selected", this.car);
        } else this.$emit("selected", null);
      },
    },
  },
  created() {
    this.getBrands();
  },
  methods: {
    /** Ensures fullDescription exists for combobox item-title / display. */
    normalizeModelsForDisplay(models) {
      return (models || []).map((m) => ({
        ...m,
        fullDescription:
          (m.fullDescription && String(m.fullDescription).trim()) ||
          m.description ||
          "",
      }));
    },

    normalizeVersionsForDisplay(versions) {
      return (versions || []).map((v) => ({
        ...v,
        fullDescription:
          (v.fullDescription && String(v.fullDescription).trim()) ||
          v.description ||
          "",
      }));
    },

    getBrands() {
      this.loadingBrand = true;
      getRequest("/info-car/brands")
        .then((response) => {
          this.brands = response.brands;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getModels(brandCode) {
      this.loadingModel = true;
      getRequest("/info-car/models", `brand_code=${brandCode}`)
        .then((response) => {
          this.models = this.normalizeModelsForDisplay(response.models);
        })
        .catch(() => {})
        .finally(() => {
          this.loadingModel = false;
        });
    },
    getVersions(brandCode, modelCode) {
      this.loadingVersion = true;
      getRequest(
        "/info-car/versions",
        `brand_code=${brandCode}&model_code=${modelCode}`,
      )
        .then((response) => {
          this.versions = this.normalizeVersionsForDisplay(response.versions);
        })
        .catch(() => {})
        .finally(() => {
          this.loadingVersion = false;
        });
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
    clear() {
      this.car = {
        brand: null,
        model: null,
        version: null,
      };
      this.brands = [];
      this.models = [];
      this.versions = [];
      this.getBrands();
    },

    async setVehicle(vehicle) {
      this.prevent = true;

      this.loadingBrand = true;
      const { brands } = await getRequest("/info-car/brands");
      this.brands = brands;
      this.car.brand = vehicle.brand;
      this.loadingBrand = false;

      this.loadingModel = true;
      const { models } = await getRequest(
        "/info-car/models",
        `brand_code=${vehicle.brand.brandCode}`,
      );
      this.models = this.normalizeModelsForDisplay(models);
      this.car.model = vehicle.model;
      this.loadingModel = false;

      this.loadingVersion = true;
      const { versions } = await getRequest(
        "/info-car/versions",
        `brand_code=${vehicle.brand.brandCode}&model_code=${vehicle.model.modelCode}`,
      );
      this.versions = this.normalizeVersionsForDisplay(versions);
      this.car.version = vehicle.version;
      this.loadingVersion = false;

      this.prevent = false;
    },

    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.advanced_search.supply.petrol");
        case "D":
          return this.$t("parts.advanced_search.supply.diesel");
        case "G":
          return this.$t("parts.advanced_search.supply.gas");
        default:
          return supply;
      }
    },
  },
};
</script>
<style scoped>
.v-combobox__selection {
  height: auto !important;
}

@media (max-width: 959.98px) {
  .select-vehicle-root {
    overflow-x: hidden;
  }

  .select-vehicle-root :deep(.v-field) {
    min-width: 0;
  }

  .select-vehicle-root :deep(.v-combobox__selection) {
    max-width: 100%;
  }
}

/* Model/version combobox mobile layout */
@media (max-width: 959px) {
  .select-vehicle-root .car-version-detail-selection {
    width: 100%;
    padding: 0.375rem 0.25rem;
  }

  .select-vehicle-root .car-version-detail-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    gap: 0.75rem 1rem;
  }

  .select-vehicle-root .car-version-detail-col {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
    flex: 1 1 0;
  }

  .select-vehicle-root .car-version-detail-col .caption {
    line-height: 1.25;
    margin-bottom: 0.125rem;
  }

  .select-vehicle-root .car-version-detail-col .font-weight-bold {
    line-height: 1.4;
    word-break: break-word;
  }

  .select-vehicle-root .car-search-combobox :deep(.v-field) {
    --v-field-padding-top: 10px;
    --v-field-padding-bottom: 10px;
    height: auto !important;
    min-height: 3.5rem;
  }

  .select-vehicle-root .car-search-version-combobox :deep(.v-field) {
    --v-field-padding-top: 12px;
    --v-field-padding-bottom: 12px;
    min-height: 4.5rem;
  }

  .select-vehicle-root .car-search-combobox :deep(.v-field__field) {
    height: auto !important;
    min-height: 3.5rem;
    align-items: flex-start;
  }

  .select-vehicle-root .car-search-version-combobox :deep(.v-field__field) {
    min-height: 4.5rem;
  }

  .select-vehicle-root .car-search-combobox :deep(.v-field__input) {
    white-space: normal;
    overflow: visible;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: unset;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .select-vehicle-root .car-search-version-combobox :deep(.v-field__input) {
    display: block !important;
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .select-vehicle-root .car-search-combobox :deep(.v-combobox__selection) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    width: 100%;
    max-width: 100%;
  }

  .select-vehicle-root .car-search-version-combobox :deep(.v-combobox__selection) {
    display: block !important;
    width: 100%;
    position: static !important;
    transform: none !important;
  }

  .select-vehicle-root .car-detail-selection {
    overflow: visible;
    width: 100%;
  }


  .select-vehicle-root .car-version-detail-row,
  .select-vehicle-root .car-version-detail-row--dropdown {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem 0.875rem;
    flex-wrap: unset;
  }

  .select-vehicle-root .car-version-detail-col {
    flex: unset;
    padding: 0;
  }

  .select-vehicle-root .car-version-detail-col--main {
    grid-column: 1 / -1;
    padding-bottom: 0.625rem;
    margin-bottom: 0.25rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .select-vehicle-root .car-version-detail-col--main .font-weight-bold {
    line-height: 1.45;
  }

  .select-vehicle-root .car-detail-col {
    flex: 1 1 calc(50% - 0.5rem);
    max-width: none;
    min-width: 0;
    padding: 0;
    word-break: break-word;
  }

  .select-vehicle-root .car-detail-selection.d-flex {
    flex-wrap: wrap;
    gap: 0.625rem 0.75rem;
  }
}
</style>
